module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showCudConfig
    }
  }, [_vm._v("连贯操作")])])])], true), _vm._v(" "), _c('cud-config', {
    ref: "cudConfig",
    attrs: {
      "modelId": _vm.modelId,
      "cudConfig": _vm.form.cud_config
    },
    on: {
      "setCudConfig": _vm.setCudConfig
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b67d2b4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/deleteConfig.vue
// module id = 1976
// module chunks = 2